module.exports = __webpack_public_path__ + "static/media/brillumex-3.f63f7e1d.jpg";